export const API_REQUEST_PROGRESS_SLICE = 'API_REQUEST_PROGRESS_SLICE';
